// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"792":"main","884":"admin"}[chunkId] + "." + {"792":"7995c2e1df95083f107d","884":"02cb926d24c0f759486f"}[chunkId] + ".css";
};